import { extendTheme } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';
import { breakpoints } from './breakpoints';

const breaks = createBreakpoints({
  sm: `${breakpoints.sm}px`,
  md: `${breakpoints.md}px`,
  lg: `${breakpoints.lg}px`,
  xl: `${breakpoints.xl}px`,
  xxl: `${breakpoints.xxl}px`,
});

export const chakraTheme = extendTheme({
  fonts: {
    heading: 'Cabin',
    body: 'Cabin',
  },
  breakpoints: breaks,
  colors: {
    primary: {
      50: '#affff1',
      100: '#79bdb6',
      200: '#54b0aa',
      300: '#34a3a0',
      400: '#189696',
      500: '#008489',
      600: '#005d63',
      700: '#00373d',
      800: '#001417',
      900: '#000000',
    },
  },
  styles: {
    global: {
      'html, body': {
        fontSize: 16,
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'primary',
      },
      variants: {
        outline: {
          bg: 'white',
          colorScheme: 'gray',
        },
        ghost: {
          _hover: {
            bg: 'gray.100',
          },
          _active: {
            bg: 'gray.200',
          },
        },
        primary: {
          bg: 'rgba(0, 132, 137, 0.16)',
          color: 'primary.600',
          border: '1px solid #E2E8F0',
          _hover: {
            bg: 'rgba(0, 132, 137, 0.26)',
          },
        },
        danger: {
          bg: 'red.100',
          color: 'red.600',
          border: 'none',
          _hover: {
            bg: 'red.200',
          },
        },
        flat: (props) => ({
          bg: `${props.colorScheme}.100`,
          color: `${props.colorScheme}.400`,
          _hover: {
            bg: `${props.colorScheme}.200`,
          },
        }),
      },
    },
    Checkbox: {
      defaultProps: {
        colorScheme: 'primary',
      },
    },
    Skeleton: {
      defaultProps: {
        startColor: 'rgba(0, 0, 0, 0.08)',
        endColor: 'rgba(0, 0, 0, 0.14)',
      },
    },
    Switch: {
      defaultProps: {
        colorScheme: 'primary',
      },
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 6,
      },
    },
    FormLabel: {
      baseStyle: {
        color: 'gray.600',
      },
    },
    AlertDialog: {
      defaultProps: {
        overlay: {
          bg: 'blackAlpha.500',
        },
      },
    },
    Modal: {
      defaultProps: {
        isCentered: true,
      },
      baseStyle: {
        overlay: {
          bg: 'blackAlpha.500',
        },
      },
    },
    Menu: {
      baseStyle: {
        list: {
          boxShadow: 'md',
          baseStyle: {},
        },
      },
    },
    Alert: {
      baseStyle: {
        container: {
          borderRadius: 6,
        },
      },
    },
    Drawer: {
      baseStyle: {
        overlay: {
          bg: 'blackAlpha.400',
        },
        header: {
          borderBottomWidth: '1px',
        },
        body: {
          py: 5,
        },
        footer: {
          borderTopWidth: '1px',
        },
      },
    },
    NumberInput: {
      baseStyle: {
        stepper: {
          '& > svg': {
            width: '8px',
            color: 'gray.500',
          },
        },
      },
    },
  },
});
